import { useTranslation } from "react-i18next";
import { InputProfile, SelectProfile } from "../../../shared/components/profile";
import { LoadingButton } from "@mui/lab";

const ManualGV = ({
    props,
    name,
    text,
    buttonText,
    handleCreateVariableManual,
    loadingCreate
}) => {
    const { t } = useTranslation();

    return (
        <div className="grid gap-y-5 w-full bg-ligh_gray rounded-xl px-2 py-3">
            <div className="text-sm">
                <p>{text}</p>
            </div>
            
            {name === "style" &&
                <div className="grid gap-y-5">
                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-tone", "Ton général")}
                      name="tone"
                      placeholder={t(
                        "placeholder-writing-style-tone",
                        "Ex : informatif neutre, passionné et engagé, éducatif bienveillant, professionnel sérieux, ludique, provocateur, inspirant…"
                      )}
                      maxLength={1000}
                      multiline={true}
                    />

                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-address", "Forme d’adresse")}
                      name="address"
                      placeholder={t(
                        "placeholder-writing-style-address",
                        'Ex : "Tu", "Vous", ou "3e personne". Précise si c’est constant ou variable selon les pages.'
                      )}
                      maxLength={500}
                      multiline={true}
                    />

                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-sentence-structure", "Structure des phrases")}
                      name="sentence_structure"
                      placeholder={t(
                        "placeholder-writing-style-sentence-structure",
                        "Ex : phrases courtes et actives, ou longues et complexes, style direct, style narratif, etc."
                      )}
                      maxLength={500}
                      multiline={true}
                    />

                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-vocabulary", "Vocabulaire utilisé")}
                      name="vocabulary"
                      placeholder={t(
                        "placeholder-writing-style-vocabulary",
                        "Ex : vocabulaire simple et accessible, technique, soutenu, imagé, scientifique, familier, etc."
                      )}
                      maxLength={500}
                      multiline={true}
                    />

                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-sources", "Source des informations")}
                      name="sources"
                      placeholder={t(
                        "placeholder-writing-style-sources",
                        "Ex : sources scientifiques citées, liens institutionnels, contenu auto-déclaré, pas de sources visibles, etc."
                      )}
                      maxLength={500}
                      multiline={true}
                    />

                    <InputProfile
                      formikProps={props}
                      type="text"
                      text={t("writing-style-excerpt", "Extrait représentatif")}
                      name="excerpt"
                      placeholder={t(
                        "placeholder-writing-style-excerpt",
                        "Colle ici un extrait de 2-3 paragraphes représentatif du style général du site."
                      )}
                      maxLength={3000}
                      multiline={true}
                    />
                </div>
            }

            {name === "company" &&
                <div className="grid gap-y-5">
                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-name", "Nom")}
                    name="name"
                    placeholder={t(
                      "placeholder-company-name",
                      "Nom exact de ton site ou de ta marque. Indique-le tel qu’il doit apparaître publiquement."
                    )}
                    maxLength={300}
                    multiline={false}
                  />

                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-website", "URL du site web")}
                    name="website"
                    placeholder={t(
                      "placeholder-company-website",
                      "Lien vers ton site principal (ex : https://mon-site.fr)."
                    )}
                    maxLength={300}
                    multiline={false}
                  />

                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-description", "Description")}
                    name="description"
                    placeholder={t(
                      "placeholder-company-description",
                      "Décris en quelques phrases ton site ou ton activité : thème principal, objectifs, mission, particularités."
                    )}
                    maxLength={1000}
                    multiline={true}
                  />

                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-audience", "Public cible")}
                    name="audience"
                    placeholder={t(
                      "placeholder-company-audience",
                      "À qui s’adresse ton contenu ou tes produits ? Décris les types de personnes que tu veux toucher (âge, centres d’intérêt, besoins...)."
                    )}
                    maxLength={1000}
                    multiline={true}
                  />

                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-offers", "Produits / Offres")}
                    name="offers"
                    placeholder={t(
                      "placeholder-company-offers",
                      "Qu’est-ce que tu proposes concrètement ? Liste les types de contenus, produits ou services disponibles (ex : articles, formations, coaching, boutique...)."
                    )}
                    maxLength={1000}
                    multiline={true}
                  />

                  <InputProfile
                    formikProps={props}
                    type="text"
                    text={t("company-positioning", "Positionnement / Marché")}
                    name="positioning"
                    placeholder={t(
                      "placeholder-company-positioning",
                      "Comment te positionnes-tu par rapport à d’autres acteurs ? Quelle est ta différence ou ta vision dans ton domaine ?"
                    )}
                    maxLength={1000}
                    multiline={true}
                  />
                </div>
            }
            
            <div className="flex justify-end">
                <LoadingButton
                    onClick={() => handleCreateVariableManual(props)}
                    loading={loadingCreate}
                    variant="contained"
                    sx={{
                    textTransform: 'none',
                    bgcolor: '#5094cf',
                    '&:hover': {
                        bgcolor: '#1a79cb'
                    }
                    }}
                >
                    {buttonText}
                </LoadingButton>
            </div>
        </div>
    )
}

export default ManualGV;